import NobuVideo from "../objects/nobu-video";
import { findElement, selectedElementAll } from "../utils/element-handlers.utils";

function NobuVideosComponent(nobuVideoElement: HTMLVideoElement) {
    var nobuVideoId = nobuVideoElement.getAttribute('data-nobu-video');
    var playPauseElement = findElement('[data-nobu-video-playpause="' + nobuVideoId + '"]');
    var muteUnmuteElement = findElement('[data-nobu-video-muteunmute="' + nobuVideoId + '"]');

    if (playPauseElement) {
        new NobuVideo(nobuVideoElement, playPauseElement, muteUnmuteElement);
    }
}

export default function initNobuVideosComponent() {
    selectedElementAll<HTMLVideoElement>('video[data-nobu-video]', NobuVideosComponent);
}
